/* Tea Lab cart drawer: keeps the cart count bubble in the header in step with the drawer.
   The theme re-renders the drawer after every add / change / remove; we read the count from it and repaint the bubble. */
(function () {
  if (window.__tldDrawerSync) return;
  window.__tldDrawerSync = true;

  var LINKS = '.tlab-hdr-cart-wrap, .tlab-hdr-stickybar-cart';
  var last = null;

  function readCount(drawer) {
    if (drawer.querySelector('[data-cart-drawer-empty]')) return 0;
    var inner = drawer.querySelector('.cart-drawer__inner');
    var n = inner ? parseInt(inner.getAttribute('data-count'), 10) : NaN;
    return isFinite(n) ? n : null;
  }

  function paint(n) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll(LINKS).forEach(function (link) {
      var bubble = link.querySelector('.tlab-hdr-cart-count');
      if (!bubble) {
        if (n < 1) return;
        bubble = document.createElement('span');
        bubble.className = 'tlab-hdr-cart-count';
        link.appendChild(bubble);
      }
      bubble.textContent = String(n);
      bubble.style.display = n < 1 ? 'none' : '';
      if (n > 0 && !reduce && bubble.animate) {
        bubble.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.35)' }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
      }
    });
  }

  // When the last item is removed without a view transition (reduced motion, low-power phones) the theme swaps the cart
  // content during the click, so the clicked button is already detached when the click reaches the drawer. The theme reads
  // that as a click outside and closes the drawer. Stop that click here so the empty cart is shown instead.
  function guardDetachedClicks(drawer) {
    var panel = drawer.querySelector('dialog');
    if (!panel) return;
    panel.addEventListener('click', function (e) {
      if (e.target instanceof Node && !e.target.isConnected) e.stopPropagation();
    }, true);
  }

  // The theme decides whether the total area stays pinned to the bottom by measuring its height against the drawer
  // (only when the drawer opens or the lines change). Ask it to measure again when something else changes the height:
  // opening the discount or note field, a discount being applied.
  function remeasure(drawer) {
    var comp = drawer.querySelector('cart-drawer-component');
    if (comp) comp.dispatchEvent(new Event('cart-section:restored', { bubbles: true }));
  }

  function init() {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    guardDetachedClicks(drawer);
    document.addEventListener('toggle', function (e) {
      if (e.target && e.target.closest && e.target.closest('#cart-drawer')) remeasure(drawer);
    }, true);
    last = readCount(drawer);
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        remeasure(drawer);
        var n = readCount(drawer);
        if (n === null || n === last) return;
        last = n;
        paint(n);
      });
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-count'] });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();